import { Toaster as Sonner } from 'sonner';
import type { ComponentProps } from 'react';
import { useTheme } from '@/hooks/useTheme';

type ToasterProps = ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();
  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // #297: the record drawer is anchored bottom-right, so toasts sit bottom-left — never over
      // a drawer control or picker popover — and the stack stays collapsed unless hovered.
      position="bottom-left"
      expand={false}
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
          success:
            'group-[.toast]:!bg-success group-[.toast]:!text-success-foreground group-[.toast]:!border-transparent',
          error:
            'group-[.toast]:!bg-destructive group-[.toast]:!text-destructive-foreground group-[.toast]:!border-transparent',
          warning:
            'group-[.toast]:!bg-notice group-[.toast]:!text-notice-foreground group-[.toast]:!border-transparent',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
